<template>
  <div class="footer_wrap">
    <div class="footer">
      <!-- <img src="../assets/pcImg/footerIcon.png" alt class="footerImg logoIc fl" /> -->
      <div class="msg_list">
        <ul class="menu_list_top">
          <li class>
            <router-link to="/aboutUs">
              <i class="c_line"></i>
              {{$t('m.footer.companyInfo')}}
            </router-link>
          </li>
          <li class>
            <router-link to="/produce">
              <i class="s_line"></i>
              {{$t('m.footer.itesGame')}}
            </router-link>
          </li>
          <li class>
            <router-link to="/recruitment">
              <i class="s_line"></i>
              {{$t('m.footer.peopleJob')}}
            </router-link>
          </li>
          <li class>
            <router-link to="/contactUs">
              <i class="s_line"></i>
              {{$t('m.footer.contactUs')}}
            </router-link>
          </li>
          <li class>
            <router-link to="/legalNotice">
              <i class="s_line"></i>
              {{$t('m.footer.legalNotice')}}
            </router-link>
          </li>
        </ul>
        <div class="clear"></div>
        <p class="footer_p">{{footer.text}}</p>
        <p class="footer_p icp_a">
          <a href="https://beian.miit.gov.cn/" target="_blank">{{footer.icp}}</a>
        </p>
        <!-- <p class="footer_p"><a href="http://www.beian.miit.gov.cn/" target="_blank">苏ICP备19042403号-2</a></p> -->
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      footer: {
        text: '版权所有 © 2012-2022 苏州爱洛克信息技术有限公司 保留所有权',
        icp: '苏ICP备19042403号-2',
      },
    }
  },
  mounted: function () {},
  methods: {},
}
</script>
<style scoped lang="scss">
.footer_wrap {
  width: 100%;
  height: 1.85rem;
  background-color: #111723;
}
.line {
  height: 0.3rem;
  width: 1px;
  padding-top: 0.2rem;
  display: inline-block;
  margin-left: 0.1rem;
}
.line_dom {
  width: 100%;
  height: 100%;
  background-color: white;
}
.footer {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  padding-top: 0.42rem;
  background-color: #111723;
}
.footer .msg_list {
  width: 100%;
}
.menu_list_top {
  display: block;
  width: 6rem;
  margin: 0 auto;
}
.menu_list_top li {
  width: auto;
  display: block;
  float: left;
}
.menu_list_top li a {
  width: 1rem;
  display: block;
  float: left;
  padding: 0 0.08rem;
  line-height: 30px;
  color: #a8a6a5;
  text-decoration: none;
  font-size: 14px;
  position: relative;
  text-align: center;
  -webkit-transition: font-weight 0.3s;
  transition: font-weight 0.3s;
  &:hover {
    color: #f08200;
  }
}

.menu_list_top li a .c_line {
  display: none;
  height: 4px;
  width: 80px;
  background: #f08200;
  overflow: hidden;
  position: absolute;
  left: 50%;
  margin-left: -40px;
  bottom: 30px;
  -webkit-transition: bottom 0.2s;
  transition: bottom 0.2s;
}
.menu_list_top li a .s_line {
  display: block;
  height: 13px;
  width: 1px;
  background: #fff;
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -6.5px;
  opacity: 0.3;
  filter: alpha(opacity=30);
}
.menu_list_top .language_1 a.current {
  opacity: 1;
  filter: alpha(opacity=100);
  color: #f08200;
}
.menu_list_top .language_1 a:hover {
  font-weight: 400;
  opacity: 1;
  filter: alpha(opacity=100);
}
.menu_list_top .language_1 .simple {
  margin-left: 20px;
}
.menu_list_top .language_1 a {
  height: 20px;
  width: auto;
  font-size: 0.14rem;
  line-height: 20px;
  margin-top: 40px;
  padding: 0 8px;
  opacity: 0.6;
  filter: alpha(opacity=60);
}
.footer {
  position: relative;
}
.footer .logoIc {
  width: 1.1rem;
  margin-top: 0.4rem;
}
.footer .footer_p {
  display: block;
  font-size: 0.14rem;
  color: #a8a6a5;
  width: 100%;
  margin-top: 0.1rem;
  text-align: center;
}
.icp_a a {
  // text-decoration: underline;
  &:hover {
    color: #f08200;
  }
}
.footer a {
  color: #a8a6a5;
  text-decoration: none;
}
</style>